import ActionType from '../actions/types';

const initialState = {
  eventId: 0,
  name: '',
  schedule: '',
  trackName: '',
  assignedCredentials: [],
  vipSingleCredentials: [],
  workingSingleCredentials: [],
  modelCredentials: [],
  vipGuestCredentials: [],
  guestWristbandCredentials: [],
  paddockGuestWristbandCredentials: [],
  vendorGuestWristbandCredentials: [],
  broadcastGuestWristbandCredentials: [],
  mediaSingleCredentials: [],
  filter: 'all',
};

export default function(state = initialState, action) {

  const {type, eventDetails, filter} = action;

  switch (type) {
    case ActionType.SET_EVENT_DETAILS:
      return {
        ...state,
        eventId: eventDetails.id,
        name: eventDetails.name,
        schedule: eventDetails.schedule,
        trackName: eventDetails.trackName,
        assignedCredentials: eventDetails.assignedCredentials,
        vipSingleCredentials: eventDetails.vipSingleCredentials,
        workingSingleCredentials: eventDetails.workingSingleCredentials,
        modelCredentials: eventDetails.modelCredentials,
        vipGuestCredentials: eventDetails.vipGuestCredentials,
        guestWristbandCredentials: eventDetails.guestWristbandCredentials,
        paddockGuestWristbandCredentials: eventDetails.paddockGuestWristbandCredentials,
        vendorGuestWristbandCredentials: eventDetails.vendorGuestWristbandCredentials,
        broadcastGuestWristbandCredentials: eventDetails.broadcastGuestWristbandCredentials,
        mediaSingleCredentials: eventDetails.mediaSingleCredentials,
      };
    case ActionType.CLEAR_EVENT_DETAILS:
      return {
        ...state,
        ...initialState,
      };
    case ActionType.CHANGE_EVENT_DETAILS_FILTER:
      return {
        ...state,
        filter,
      };
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/eventDetails.js